import * as React from "react";

function SvgIcPhone(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.934 12.748a.946.946 0 00-1.34 0l-1.509 1.51c-.7-.208-2.006-.682-2.834-1.51-.827-.827-1.301-2.133-1.51-2.833l1.51-1.51a.946.946 0 000-1.339L7.463 3.278a.946.946 0 00-1.34 0L3.556 5.846c-.36.36-.562.854-.555 1.36.022 1.348.379 6.032 4.07 9.724 3.693 3.691 8.377 4.047 9.727 4.07h.026c.5 0 .973-.197 1.33-.555l2.57-2.568a.946.946 0 000-1.34l-3.79-3.789zm-.12 6.357c-1.182-.02-5.226-.337-8.404-3.516-3.188-3.187-3.497-7.245-3.516-8.404l1.9-1.899 2.449 2.45L8.018 8.96a.947.947 0 00-.258.864c.023.109.579 2.691 2.151 4.263 1.572 1.572 4.155 2.128 4.264 2.151a.939.939 0 00.864-.256l1.225-1.225 2.45 2.45-1.9 1.898z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcPhone;
